var React = require('react');

function AwardsWave (props) {
    return React.createElement("svg",props,React.createElement("g",{"style":{"mixBlendMode":"multiply"}},React.createElement("path",{"d":"M98.5147 15C74.3441 20.4726 48.7936 28.3607 27.9847 42.1356C10.2124 53.9003 10.1456 64.001 31.1243 69.4954C46.149 73.4305 61.7048 76.2258 77.0978 78.2416C78.4898 78.4239 92.6302 78.2596 94.0295 80.7085C96.3929 84.8443 54.2132 106.14 51.7563 107.62C46.1172 111.015 35.854 115.777 31.685 121.524C26.9263 128.083 50.2637 131.914 50.9714 132.064C60.6328 134.109 165.209 143.035 164.896 145.071C163.737 152.607 137.249 161.668 132.827 163.685C108.909 174.595 83.9267 183.356 60.3904 195.082C45.6856 202.407 20.1694 215.103 25.8542 235","stroke":"#40E0D0","strokeWidth":"29.2661","strokeLinecap":"round","strokeLinejoin":"round"})));
}

AwardsWave.defaultProps = {"width":"180","height":"250","viewBox":"0 0 180 250","fill":"none"};

module.exports = AwardsWave;

AwardsWave.default = AwardsWave;
